import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
//import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import Grid from '@material-ui/core/Grid'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import SaveIcon from '@material-ui/icons/Save'

import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Snackbar from '@material-ui/core/Snackbar'
import Fade from '@material-ui/core/Fade'

import red from '@material-ui/core/colors/red'

import ProfileDetailsCard from './ProfileDetailsCard'
import ImageInput from './ImageInput'

import * as API from '../../utils/api'
import { formatComment } from '../../helpers'

import serializeForm from 'form-serialize'

import t from '../../utils/lang/user'

const styles = theme => ({
  appBar: {
    position: 'fixed',
    backgroundColor: '#f5f5f5',
    color: '#414042'
  },
  root: {
    width: 'calc(100% + 4px)',
    marginTop: '64px',
    padding: '10px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '56px',
      padding: '5px'
    }
  },
  toolbar: {
  	padding: '0'
  },
  flex: {
    flex: 1,
  },
  cardHeader: {
    fontWeight: '500'
  },
  buildingItem: {
    padding: '0',
    fontSize: '0.9em'
  },
  buildingPhoto: {
    width: '120px'
  },
  listItemPrimary: {
  	color: 'rgba(0, 0, 0, 0.54)'
  },
  listItemSecondary: {
  	color: 'rgba(0, 0, 0, 0.87)'
  },
  commentItemPrimary: {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  commentItemSecondary: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '0.8125rem',
    fontStyle: 'italic'
  },
  userContainer: {
    marginTop: '15px',
    textAlign: 'center'
  },
  userName: {
    margin: '5px 0 20px',
    fontSize: '1.1rem'
  },
  myTeam: {
    margin: '30px 0 5px',
    fontSize: '1.1rem'
  },
  avatarContainer: {
    width: '150px',
    height: '150px',
    margin: '0 auto'
  },
  avatarInput: {
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
    backgroundImage: 'url(/static/images/icons/person.svg)',
    backgroundSize: '64px 64px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: '50%',
  },
  changePhotoInput: {
    width: '100%',
    height: '100%',
    top: '-150px',
    backgroundColor: 'white',
    backgroundImage: 'url(/static/images/icons/edit.svg)',
    backgroundSize: '24px 24px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    borderRadius: '50%',
    opacity: '0'
  },
  avatarPhoto: {
    width: '150px',
    height: '150px',
    margin: '0 auto',
  },
  memberList: {
    display: 'flex',
    justifyContent: 'center',
    paddingLeft: '15px'
  },
  teamMember: {
    width: 'auto',
    padding: '0',
    marginLeft: '-15px'
  },
  memberAvatar: {
    backgroundColor: red[500]
  },
  saveButton: {
    position: 'fixed',
    bottom: '15px',
    right: '15px'
  },
  noBuildings: {
    padding: '16px 24px'
  }
});

class Profile extends Component {
	state = {
    enquiry: {},
    redirect: false,
    snackbarOpen: false
  }

  componentDidMount () {
    //const { id } = this.props
  }

  handleOpenSnackbar = () => {
    this.setState({ snackbarOpen: true })
  }

  handleCloseSnackbar = () => {
    this.setState({ snackbarOpen: false })
  }

  handleGoBack = () => {
    const { history } = this.props

    if (history.action === 'PUSH') {
      history.goBack()
    } else {
      history.push('/')
    }
  }

  handleSave = e => {
    const { dispatch } = this.props

    //console.log('test')
  }

  /*handleSubmit = e => {
    const { dispatch } = this.props

    e.preventDefault();

    //const files = Array.from(e.target.files)

    const form = document.querySelector('#user-form');

    const values = serializeForm(form, { hash: true })
    console.log(values)

    //const formData = new FormData()

    files.forEach((file, i) => {
      formData.append(i, file, file.name)
    })
  }*/

	render() {
		const { id, classes, user, myTeam } = this.props
    const assignedBuildings = user ? user.assignedBuildings : []
    const lang = 'en'

		return (
			<div>
        <AppBar className={classes.appBar}>
          <Toolbar className={classes.toolbar}>
            <IconButton color="inherit" onClick={this.handleGoBack}>
              <KeyboardBackspaceIcon />
            </IconButton>
            <Typography variant="title" color="inherit" className='enquiry-title'>
              {t[lang].myProfile}
            </Typography>
          </Toolbar>
        </AppBar>

        <Grid container spacing={8} className={classes.root}>
          <Grid item xs={12} sm={2} md={2} className={classes.userContainer}>
            <Typography variant="title" className={classes.userName}>{user.name}</Typography>
            <div className={classes.avatarContainer}>
              {user.avatar !== '' && (<Avatar alt={user.name} src={`/static/images/avatars/${user.avatar}`} className={classes.avatarPhoto} />)}
              <ImageInput
                className={user.avatar !== '' ? classes.changePhotoInput : classes.avatarInput}
                userId={user.id}
                name='avatarURL'
                maxHeight={64}
              />
            </div>
            <Typography variant="caption" className={classes.myTeam}>{t[lang].myTeam}</Typography>

            <List className={classes.memberList}>
              {myTeam.map((member, index) => (
                <ListItem key={index} disableGutters={true} className={classes.teamMember}>
                  {member.avatar !== ''
                    ? <Avatar alt={member.initials} src={`/static/images/avatars/${member.avatar}`} />
                    : <Avatar className={classes.memberAvatar}>{member.initials}</Avatar>}
                </ListItem>
              ))}
            </List>

            {myTeam.length === 0 && (<Typography gutterBottom>You are the only member of your team.</Typography>)}
          </Grid>
          <Grid item xs={12} sm={5} md={5} style={{ padding: '10px' }}>
            <ProfileDetailsCard />
          </Grid>
          <Grid item xs={12} sm={5} md={5} style={{ padding: '10px' }}>
            <Card>
              <CardHeader
                title="Assigned buildings"
                classes={{ title: classes.cardHeader }}
              />
              <Divider />
              <List style={{ padding: '0' }}>
                {typeof assignedBuildings === 'object' && assignedBuildings.map((building) =>
                  <Fragment key={building.id}>
                    <Link to={`/office/${building.id}`}>
                      <ListItem className={classes.buildingItem}>
                        <img src={building.photo} alt={building.name} className={classes.buildingPhoto} />
                        <ListItemText secondary={building.name} classes={{ secondary: classes.listItemSecondary }} />
                      </ListItem>
                    </Link>
                    <Divider />
                  </Fragment>
                )}
                {assignedBuildings.length === 0 && (<Typography className={classes.noBuildings}>You have no assigned buildings.</Typography>)}
              </List>
            </Card>
          </Grid>
        </Grid>

        {/*<Button
          variant="fab"
          color='secondary'
          className={classes.saveButton}
          //type="submit"
        >
          <SaveIcon />
        </Button>*/}

        <Snackbar
          open={this.state.snackbarOpen}
          onClose={this.handleCloseSnackbar}
          TransitionComponent={Fade}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          message={<span id="message-id">Changes have been saved.</span>}
        />
      </div>
		)
	}
}

function mapStateToProps ({ users, authedUser }, props) {
  //const myTeam = Object.values(users).filter((user) => (user.id !== authedUser.id)).map((user) => user.initials).sort((a,b) => a.localeCompare(b))
  const myTeam = Object.values(users).filter((user) => (user.id !== authedUser.id)).map((user) => ({initials: user.initials, avatar: user.avatar})).sort((a,b) => a.initials.localeCompare(b.initials))

  return {
    user: authedUser,
    accountId: authedUser.accountId,
    myTeam
  }
}

export default connect(mapStateToProps)(withRouter(withStyles(styles)(Profile)))


// WEBPACK FOOTER //
// ./src/components/Users/Profile.js